import gql from "graphql-tag";

export default gql`
  query CustomerContracts($customerId: ID, $offset: Int, $limit: Int) {
    customerContracts(customerId: $customerId, offset: $offset, limit: $limit) {
      items {
        id
        customerId
        name
        description
        deploymentId
      }
      total
    }
  }
`;
